//src/app/features/conversations/Components/ConversationLayout/index.tsx
import { Container } from 'app/layout/dashboardLayout/BoxLayout';
import React from 'react';

export default function ConversationLayout({
  header,
  content,
  footer,
}: {
  header?: React.ReactNode;
  footer: React.ReactNode;
  content: React.ReactNode;
}) {
  return (
    <Container>
      {header && (
        <div className="px-4 font-black h-20 border-b shrink-0 border-gray-dark border-opacity-10 flex items-center justify-between">
          {header}
        </div>
      )}
      <div className="overflow-y-auto flex-1 flex flex-col">{content}</div>
      <div className="max-w-full justify-end">{footer}</div>
    </Container>
  );
}
